
import { defineComponent} from 'vue'
import QrcodeVue from 'qrcode.vue'
import {VueSpinnerPie} from 'vue3-spinners'
import { useToast } from 'vue-toastification'

export default defineComponent({
    name:'Home',
    // mounted(){
    // },
    setup(){
      const toast = useToast();
      return {toast}
    },
    data(){
      return{
        url:'',
        foreground:'#000000',
        value:'',
        size:300,
        showSpinner:false,
        customColor:''
      }
    },
    computed:{
    // background(){
    //     return this.defaultColor === ''? 'black': this.defaultColor
    // } 
    },
    watch:{
      customColor(){
        this.foreground = this.customColor
      }
    },
    components:{
        QrcodeVue,
        VueSpinnerPie
    },
    methods:{
        getCode(){
            this.value = '';
            this.showSpinner = true;
            setTimeout(()=>{
               this.showSpinner = false;
                this.value = this.url;
                this.toast.success("QR code generated",{
                    timeout:3000
                })
            },3000)
        },
        changeColor(e:any) {
           this.foreground=  e.target.id
        },
        changeHeader(e:any){
          
        }
    }
    
})

